var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronLeftCircleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16 2.32083C8.45721 2.32083 2.32086 8.45711 2.32086 15.9998C2.32086 23.5425 8.45721 29.6792 16 29.6792C23.5428 29.6792 29.6791 23.5425 29.6791 15.9998C29.6791 8.45711 23.5428 2.32083 16 2.32083ZM16 32C7.17764 32 0 24.8221 0 15.9998C0 7.17756 7.17764 0 16 0C24.8224 0 32 7.17756 32 15.9998C32 24.8221 24.8224 32 16 32Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.5893 16.061L18.9816 12.6687C19.4806 12.1697 19.4806 11.3574 18.9816 10.8584C18.4826 10.3595 17.6703 10.3595 17.1713 10.8584L13.779 14.2507L11.9688 16.061L13.779 17.8712L17.1713 21.2635C17.6703 21.7663 18.4826 21.7663 18.9816 21.2635C19.4806 20.7645 19.4806 19.9522 18.9816 19.4532L15.5893 16.061Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftCircleIcon);
export default __webpack_public_path__ + "static/media/chevron_left_circle-icon.cf9647b90669953b6aa56ab84d9d8d84.svg";
export { ForwardRef as ReactComponent };